module.exports = __webpack_public_path__ + "img/epixeiriseis ekptoseis.dcc79276.jpg";